import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error("Uncaught error:", error, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback)
                return this.props.fallback;
            return (_jsx("div", { style: containerStyle, children: _jsxs("div", { style: cardStyle, children: [_jsx("p", { style: { fontSize: 32, marginBottom: 12 }, children: "\u26A0\uFE0F" }), _jsx("h2", { style: { color: "#0f172a", fontSize: 18, fontWeight: 700, marginBottom: 8 }, children: "Something went wrong" }), _jsx("p", { style: { color: "#64748b", fontSize: 13, marginBottom: 20, maxWidth: 360, textAlign: "center" }, children: this.state.error?.message ?? "An unexpected error occurred." }), _jsx("button", { onClick: () => this.setState({ hasError: false, error: null }), style: btnStyle, children: "Try again" })] }) }));
        }
        return this.props.children;
    }
}
const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "#f8fafc",
};
const cardStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 48px",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 20,
    boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
};
const btnStyle = {
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "10px 24px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(99,102,241,0.3)",
};
